import { Route } from '@angular/router';
import { GameMode } from '@dc-core/dc-backend/dc-enums';
import { gamesLocalLeaveBusterGuard } from 'src/app/modules/games/guards/games-local-leave-buster.guard';
import { gamesTrialGuard } from 'src/app/modules/games/guards/games-trial.guard';

export const checkout121LocalGameRoutes: Route[] = [
    {
        path: 'local-games/checkout-121',
        loadComponent: () =>
            import('./pages/checkout-121-new-game/checkout-121-new-game.component').then(
                (c) => c.Checkout121NewGameComponent
            ),
    },
    {
        path: 'game/checkout-121',
        data: {
            gameMode: 'checkout_121' as GameMode,
        },
        canActivate: [gamesTrialGuard],
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/checkout-121-local-game-app/checkout-121-local-game-app.component').then(
                (c) => c.Checkout121LocalGameAppComponent
            ),
    },
];

export const checkout121VenueLocalGameRoutes: Route[] = [
    {
        path: 'local-games/checkout-121',
        loadComponent: () =>
            import('./pages/checkout-121-new-game/checkout-121-new-game.component').then(
                (c) => c.Checkout121NewGameComponent
            ),
    },
    {
        path: 'game/checkout-121',
        data: {
            gameMode: 'checkout_121' as GameMode,
        },
        canActivate: [gamesTrialGuard],
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/checkout-121-local-game-venue/checkout-121-local-game-venue.component').then(
                (c) => c.Checkout121LocalGameVenueComponent
            ),
    },
];
